__turbopack_context__.v({
  "actionBtn": "ObjectiveSelector-module__O1cBaW__actionBtn",
  "container": "ObjectiveSelector-module__O1cBaW__container",
  "head": "ObjectiveSelector-module__O1cBaW__head",
  "headActions": "ObjectiveSelector-module__O1cBaW__headActions",
  "label": "ObjectiveSelector-module__O1cBaW__label",
  "menuAction": "ObjectiveSelector-module__O1cBaW__menuAction",
  "option": "ObjectiveSelector-module__O1cBaW__option",
  "optionActive": "ObjectiveSelector-module__O1cBaW__optionActive",
  "optionLabel": "ObjectiveSelector-module__O1cBaW__optionLabel",
  "pill": "ObjectiveSelector-module__O1cBaW__pill",
  "pillArrow": "ObjectiveSelector-module__O1cBaW__pillArrow",
  "pillDescription": "ObjectiveSelector-module__O1cBaW__pillDescription",
  "pillLabel": "ObjectiveSelector-module__O1cBaW__pillLabel",
  "pillText": "ObjectiveSelector-module__O1cBaW__pillText",
  "pillWrapper": "ObjectiveSelector-module__O1cBaW__pillWrapper",
  "popover": "ObjectiveSelector-module__O1cBaW__popover",
});
